import { QUERY_KEYS } from "@/src/config/constant";

export const fitnessQueryKeys = {
  score: () => [QUERY_KEYS.FITNESS_SCORE] as const,
  goalImpact: (goalId: string) =>
    [QUERY_KEYS.GOAL_FITNESS_IMPACT, goalId] as const,
};
